class AlfanumericoForm {
    alfanumerico = {
      value: '',
      required: false,
      state: null
    }
}

class AlfanumericoData {
    alfanumerico = null
}

export { AlfanumericoForm, AlfanumericoData }



// WEBPACK FOOTER //
// ./src/views/private/configurations/person/components/add/alfanumerico-form.js